import { companiesUrl, loadCompanies } from '../Services';

import React from 'react';
import localforage from 'localforage';
import useSWR from 'swr';

const loadFromLocalForage = async key => {
    return await localforage.getItem(key);
};

const saveToLocalForage = async (key, data) => {
    await localforage.setItem(key, data);
};

export const withCompanies = Component => {
    return function WrappedComponent(props) {
        const { app } = props;
        const { currentUser } = app;
        const companiesKey = currentUser.uuid + '-' + companiesUrl;
        const fetcher = async () => {
            return await loadCompanies(currentUser.organizations[0].uuid);
        };
        const { data, error, isLoading, isValidating, mutate } = useSWR(
            companiesKey,
            fetcher,
            {
                onLoadingSlow: async () => {
                    const cachedData = await loadFromLocalForage(companiesKey);

                    if (cachedData) {
                        mutate(cachedData, false);
                    }
                },
                loadingTimeout: 2500,
                onSuccess: async data => {
                    await saveToLocalForage(companiesKey, data);
                },
                revalidateOnMount: true,
                revalidateIfStale: false,
                revalidateOnFocus: false,
                revalidateOnReconnect: false,
            }
        );

        return (
            <Component
                {...props}
                data={data}
                error={error}
                isLoading={typeof data !== 'undefined' ? false : isLoading}
                isValidating={isValidating}
                reloadCompanies={mutate}
            />
        );
    };
};
